import { render } from "./index.vue?vue&type=template&id=5b70d621&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.css?vue&type=style&index=0&id=5b70d621&lang=css&scoped=true"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b70d621"]])

export default __exports__